import { cn } from '@/lib/utils'
import Image from 'next/image'
import React from 'react'
import styles from './ProductTwoColumn.module.css'

type Props = {
  headerText: string
  headerTextColor?: string
  content: string
  imageSrc: string
  imageAlt: string
  isImgFirst: boolean
  className?: string
  backgroundColor: string
}

export const ProductTwoColumnBannerSection = ({
  headerText,
  headerTextColor,
  content,
  imageSrc,
  imageAlt,
  isImgFirst,
  backgroundColor,
  className,
}: Props) => (
  <div
    style={{ backgroundColor }}
    className={cn(
      'flex h-auto w-full flex-col lg:w-full lg:flex-row lg:items-center lg:justify-center',
      className,
      isImgFirst ? 'pt-20 pb-4 lg:p-8' : 'pt-4 pb-20 lg:p-8',
    )}
    data-test="product-column-banner"
  >
    <div
      className={cn(
        'flex min-w-[50%] flex-1 justify-center py-4 lg:py-0',
        isImgFirst
          ? 'order-first lg:order-last lg:justify-start'
          : 'order-last lg:order-first lg:justify-end',
      )}
    >
      <span
        className={cn(
          'flex max-w-[29.25rem] flex-col items-center p-5 lg:ml-0',
          isImgFirst ? 'lg:ml-20' : 'lg:mr-20',
        )}
      >
        <h2
          className={cn(
            'align-baseline text-[48px] leading-tight font-semibold text-primary max-lg:text-4xl lg:w-full',
            headerTextColor ? `[color:${headerTextColor}]` : 'text-primary',
          )}
          aria-label="Header"
          data-test="product-column-banner-title"
        >
          {headerText}
        </h2>

        <div
          dangerouslySetInnerHTML={{ __html: content }}
          className={cn(
            styles.list,
            'mt-7 list-disc text-lg leading-snug text-primary lg:w-full',
          )}
        />
      </span>
    </div>
    <div
      className={cn(
        'mx-5 my-8 flex flex-1 justify-center lg:mx-0 lg:max-w-[50%]',
        isImgFirst ? 'lg:justify-end' : 'lg:justify-start',
      )}
    >
      <Image
        src={imageSrc}
        alt={imageAlt}
        height={600}
        width={600}
        className="max-w-[90%] object-cover object-top p-0"
        data-test="product-column-banner-image"
      />
    </div>
  </div>
)
